<template>
  <div id="playground" @touchstart="touchStart" @touchend="touchEnd">
    <h3>{{ msg }}</h3>
    <!-- --------------- <CONFIG> -------------------- -->
    <div class="flexCenter">
      <div class="configPanel">
        <Transition name="bounce">
          <div v-if="showConfig" class="configPanelElement">
            Cells (2 to 9):
            <input
              style="width: 100px"
              maxlength="1"
              type="number"
              v-model.number="this.limit"
              @change="
                () => {
                  if (this.limit > 9 || this.limit < 2) {
                    this.limit = 4;
                  }
                }
              "
            />
            <br />
            <br />
            <a href="#" v-on:click.prevent="showConfig = !showConfig">Close</a>
          </div>
        </Transition>

        <Transition name="bounce">
          <div v-if="!showConfig" class="configPanelElement">
            <a href="#" v-on:click.prevent="startGame">New Game</a>
            &nbsp;
            <a href="#" v-on:click.prevent="showConfig = !showConfig">Config</a>
          </div>
        </Transition>
      </div>
    </div>
    <!-- --------------- </CONFIG> -------------------- -->

    <!-- --------------- </USER MESSAGES> -------------------- -->
    <Transition name="bounce">
      <div v-if="!showConfig" class="flexCenter" style="flex-direction: column">
        <div v-if="userMessage != null" class="userMessage">
          {{ userMessage }}
        </div>
        <div class="shake">
          Points: {{ points }} &nbsp;&nbsp; Moves: {{ moves }} <br />
          <b>Score: {{ score }}</b>
        </div>
      </div>
    </Transition>
    <!-- --------------- </USER MESSAGES> -------------------- -->

    <!-- --------------- </GRID> -------------------- -->

    <div>
      <div v-if="this.readyToPlay" class="shake">
        <div v-for="(x, index) in matrix" :key="index" style="display: block">
          <div
            v-for="(y, index) in x"
            :key="index"
            style="display: inline-block"
          >
            <div
              :style="
                'max-width:' + maxWidth + 'px; max-height:' + maxHeight + 'px; '
              "
              :class="[
                y == 2
                  ? 'cell2'
                  : y == 4
                  ? 'cell4'
                  : y == 8
                  ? 'cell8'
                  : y == 16
                  ? 'cell16'
                  : y == 32
                  ? 'cell32'
                  : y == 64
                  ? 'cell64'
                  : y == 128
                  ? 'cell128'
                  : y == 256
                  ? 'cell256'
                  : '',
                'cell',
                y > 0 ? movementClass : '',
              ]"
            >
              <span class="cellText" v-if="y > 0">{{ y }}</span>
              <span class="cellText" v-if="y == 0">&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- --------------- </GRID> -------------------- -->
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      matrix: [],
      limit: 4,
      mergeLimit: 257,
      touchstartX: 0,
      touchstartY: 0,
      touchendX: 0,
      touchendY: 0,
      points: 0,
      moves: 0,
      readyToPlay: false,
      userMessage: null,
      showConfig: false,
      isMobile: true,
      maxWidth: "80",
      maxHeight: "80",
      windowWidth: window.innerWidth,
      movementClass: "",
    };
  },
  watch: {
    limit(newValue) {
      console.log(newValue);
      if (1 < newValue < 10) this.startGame();
      else this.limit = 4;
    },
  },
  computed: {
    score() {
      if (this.points > 0 && this.moves > 0)
        return Math.round(this.points / this.moves, 0);
      return 0;
    },
  },
  methods: {
    createMatrix() {
      this.matrix = [];
      for (var i = 0; i < this.limit; i++) {
        this.matrix[i] = [];
        for (var j = 0; j < this.limit; j++) {
          this.matrix[i][j] = 0;
        }
      }
    },
    setValue(y, x, value) {
      for (let i = 0; i < this.limit; i++) {
        for (let z = 0; z < this.limit; z++) {
          if (y === i && x === z) this.matrix[i][z] = value;
        }
      }
    },
    addPoints(p) {
      this.points += p;
    },
    // ------------------------------------------ L E F T
    // moves left the x line
    moveLeft(x, hasMerged) {
      var hasMoved = false;
      for (let i = 0; i < this.limit; i++) {
        if (i > 0 && this.matrix[x][i] > 0) {
          // if empty
          if (this.matrix[x][i - 1] === 0) {
            this.matrix[x][i - 1] = this.matrix[x][i];
            this.matrix[x][i] = 0;
            hasMoved = true;
          }
          // if same values: merge them!
          if (
            this.matrix[x][i - 1] === this.matrix[x][i] &&
            this.matrix[x][i] + this.matrix[x][i - 1] <= hasMerged
          ) {
            this.matrix[x][i - 1] = this.matrix[x][i] + this.matrix[x][i - 1];
            this.matrix[x][i] = 0;
            hasMoved = true;
            this.addPoints(this.matrix[x][i - 1]);
            hasMerged = this.matrix[x][i - 1];
          }
        }
      }
      return { hasMoved: hasMoved, hasMerged: hasMerged };
    },
    swipeLeft() {
      for (let i = 0; i < this.limit; i++) {
        let _hasMerged = this.mergeLimit;
        var loop = true;
        while (loop) {
          let { hasMoved, hasMerged } = this.moveLeft(i, _hasMerged);
          _hasMerged = hasMerged;
          if (!hasMoved) loop = false;
        }
      }
    },
    // ---------------------------------------  R I G H T
    moveRight(x, hasMerged) {
      var hasMoved = false;
      for (let i = this.limit; i >= 0; i--) {
        if (i < this.limit && this.matrix[x][i] > 0) {
          // if empty
          if (this.matrix[x][i + 1] === 0) {
            this.matrix[x][i + 1] = this.matrix[x][i];
            this.matrix[x][i] = 0;
            hasMoved = true;
          }
          // if same values: merge them!
          if (
            this.matrix[x][i + 1] === this.matrix[x][i] &&
            this.matrix[x][i] + this.matrix[x][i + 1] <= hasMerged
          ) {
            this.matrix[x][i + 1] = this.matrix[x][i] + this.matrix[x][i + 1];
            this.matrix[x][i] = 0;
            this.addPoints(this.matrix[x][i + 1]);
            hasMoved = true;
            hasMerged = this.matrix[x][i + 1];
          }
        }
      }
      return { hasMoved: hasMoved, hasMerged: hasMerged };
    },
    swipeRight() {
      for (let i = 0; i < this.limit; i++) {
        let _hasMerged = this.mergeLimit;
        var loop = true;
        while (loop) {
          let { hasMoved, hasMerged } = this.moveRight(i, _hasMerged);
          _hasMerged = hasMerged;
          //this.sleep(0.5);
          if (!hasMoved) loop = false;
        }
      }
    },
    // sleep(seconds) {
    //   var e = new Date().getTime() + seconds * 1000;
    //   while (new Date().getTime() <= e) {}
    // },
    // ------------------------------------------ U P
    moveUp(x, hasMerged) {
      var hasMoved = false;
      for (let i = 0; i < this.limit; i++) {
        if (i > 0 && this.matrix[i][x] > 0) {
          // if empty
          if (this.matrix[i - 1][x] === 0) {
            this.matrix[i - 1][x] = this.matrix[i][x];
            this.matrix[i][x] = 0;
            hasMoved = true;
          }
          // if same values: merge them!
          if (
            this.matrix[i - 1][x] === this.matrix[i][x] &&
            this.matrix[i][x] + this.matrix[i - 1][x] <= hasMerged
          ) {
            this.matrix[i - 1][x] = this.matrix[i][x] + this.matrix[i - 1][x];
            this.matrix[i][x] = 0;
            this.addPoints(this.matrix[i - 1][x]);
            hasMoved = true;
            hasMerged = this.matrix[i - 1][x];
          }
        }
      }
      return { hasMoved: hasMoved, hasMerged: hasMerged };
    },
    swipeUp() {
      for (let i = 0; i < this.limit; i++) {
        let _hasMerged = this.mergeLimit;
        var loop = true;
        while (loop) {
          let { hasMoved, hasMerged } = this.moveUp(i, _hasMerged);
          _hasMerged = hasMerged;
          if (!hasMoved) loop = false;
        }
      }
    },
    // ------------------------------------------  D O W N
    moveDown(x, hasMerged) {
      var hasMoved = false;
      for (let i = this.limit; i >= 0; i--) {
        if (i < this.limit - 1 && this.matrix[i][x] > 0) {
          // if empty
          if (this.matrix[i + 1][x] === 0) {
            this.matrix[i + 1][x] = this.matrix[i][x];
            this.matrix[i][x] = 0;
            hasMoved = true;
          }
          // if same values: merge them!
          if (
            this.matrix[i + 1][x] === this.matrix[i][x] &&
            this.matrix[i][x] + this.matrix[i + 1][x] <= hasMerged
          ) {
            this.matrix[i + 1][x] = this.matrix[i][x] + this.matrix[i + 1][x];
            this.matrix[i][x] = 0;
            hasMoved = true;
            this.addPoints(this.matrix[i + 1][x]);
            hasMerged = this.matrix[i + 1][x];
          }
        }
      }
      return { hasMoved: hasMoved, hasMerged: hasMerged };
    },
    swipeDown() {
      for (let i = 0; i < this.limit; i++) {
        let _hasMerged = this.mergeLimit;
        var loop = true;
        while (loop) {
          let { hasMoved, hasMerged } = this.moveDown(i, _hasMerged);
          _hasMerged = hasMerged;
          if (!hasMoved) loop = false;
        }
      }
    },
    // ------------------------------------------- N E W    C E L L
    rand(max) {
      return Math.floor(Math.random() * max);
    },
    createNewCellWithValue(n) {
      let a = this.rand(this.limit);
      let b = this.rand(this.limit);
      //console.log(n + " - createNewCellWithValue: " + a + "," + b);
      if (this.matrix[a][b] === 0) this.matrix[a][b] = 2;
      else {
        //overflow protection
        if (n < 20) {
          this.createNewCellWithValue(n + 1);
        } else return;
      }
    },
    // ----------------------------- U I   G E S T U R E S
    handleGesture() {
      if (
        this.touchendY < this.touchstartY &&
        this.touchstartY - this.touchendY > 50
      ) {
        this.swipeUp();
        this.movementClass = "fromDown";
        return true;
      }

      if (
        this.touchendY > this.touchstartY &&
        this.touchendY - this.touchstartY > 50
      ) {
        //console.log("Swiped Down");
        this.swipeDown();
        this.movementClass = "fromUp";
        return true;
      }

      if (this.touchendX < this.touchstartX) {
        //console.log("Swiped Left");
        this.swipeLeft();
        this.movementClass = "fromRight";
        return true;
      }

      if (this.touchendX > this.touchstartX) {
        //console.log("Swiped Right");
        this.swipeRight();
        this.movementClass = "fromLeft";
        return true;
      }

      if (this.touchendY === this.touchstartY) {
        //console.log("Tap");
        return false;
      }
    },
    touchStart(event) {
      this.touchstartX = event.changedTouches[0].screenX;
      this.touchstartY = event.changedTouches[0].screenY;
    },
    touchEnd(event) {
      this.touchendX = event.changedTouches[0].screenX;
      this.touchendY = event.changedTouches[0].screenY;
      if (this.handleGesture()) {
        this.moves++;
        setTimeout(() => {
          this.movementClass = "";
          this.createNewCellWithValue(0);
        }, 300);
      }
    },
    setCellSide() {
      var c = this.limit < 5 ? 1 : 2;
      c = Math.min(this.windowWidth / (this.limit * c), 80);
      this.maxWidth = c;
      this.maxHeight = c;
    },
    // ------------------------------------------- S T A R T
    startGame() {
      if (this.limit > 9) return;

      this.readyToPlay = false;
      this.setCellSide();
      this.createMatrix();
      this.points = 0;
      this.moves = 0;
      this.setValue(0, 2, 2);
      this.setValue(0, 1, 2);
      setTimeout(() => (this.readyToPlay = true), 500);
    },
  },
  // ------------------------------------------- M O U N T E D
  mounted() {
    if (!window.matchMedia("(any-hover: none)").matches) {
      this.isMobile = false;
      this.userMessage = "IMPORTANT: You need a touch screen to play!";
    }

    this.startGame();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#playground {
  /* border: solid 1px #222; */
  height: 70vh;
}
h3 {
  margin: 0.5rem;
}
div {
  text-align: center;
}
.configPanelElement {
  width: 300px;
  background-color: rgb(44, 3, 31);
  border-radius: 20px;
  padding: 10px;
}
.flexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}
.configPanel,
.configPanel a {
  color: rgb(201, 76, 201);
  padding: 6px;
}
input {
  padding: 5px;
  font-size: 18px;
  border-width: 2px;
  border-color: #f908f4;
  background-color: #551b71;
  color: #08f99d;
  border-style: dashed;
  border-radius: 17px;
  box-shadow: 0px 0px 5px rgba(66, 66, 66, 0.75);
  text-shadow: 0px 0px 5px rgba(66, 66, 66, 0.75);
}
.userMessage {
  background-color: rgb(146, 8, 72);
  padding: 1rem;
  border-radius: 1.5rem;
  margin: 1rem;
  font-weight: 800;
  text-align: center;
  width: 250px;
}
/* ----------------------------------------- */
.cell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15vw;
  /* max-width: 80px; */
  height: 15vw;
  /* max-height: 80px; */
  text-align: center;
  border: solid 1px rgb(68, 107, 107);
  font-size: large;
  font-weight: 600;
  border-radius: 1rem;
  margin: 0.15rem;
}
.cell2 {
  background-color: #e051fd;
}
.cell4 {
  background-color: #aa29c4;
}
.cell8 {
  background-color: #84089c;
}
.cell16 {
  background-color: #610374;
}
.cell32 {
  background-color: #430550;
}
.cell64 {
  background-color: #680202;
}
.cell128 {
  background-color: #970000;
}
.cell256 {
  background-color: #be1414;
}
/* ----------------------------------------- */
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
/* ----------------------------------------- */
.bounce-enter-active {
  animation: bounce-in 0.4s;
}
.bounce-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}
/* ----------------------------------------- */
.bounce2-enter-active {
  animation: bounce2-in 0.2s;
}
.bounce2-leave-active {
  animation: bounce2-in 0.2s reverse;
}
@keyframes bounce2-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
/* -----------------------------------------   M O V E M E N T S  */
.fromLeft {
  animation: from-left 0.3s;
  /* transform: translate3d(0, 0, 0); */
}
@keyframes from-left {
  0% {
    transform: translateX(-8px);
  }
  100% {
    transform: translateX(0);
  }
}
/* ----------------------------------------- */
.fromRight {
  animation: from-right 0.3s;
  /* transform: translate3d(0, 0, 0); */
}
@keyframes from-right {
  0% {
    transform: translateX(8px);
  }
  100% {
    transform: translateX(0);
  }
}
/* ----------------------------------------- */
.fromUp {
  animation: from-up 0.3s;
  /* transform: translate3d(0, 0, 0); */
}
@keyframes from-up {
  0% {
    transform: translateY(-8px);
  }
  100% {
    transform: translateY(0);
  }
}
/* ----------------------------------------- */
.fromDown {
  animation: from-down 0.3s;
  /* transform: translate3d(0, 0, 0); */
}
@keyframes from-down {
  0% {
    transform: translateY(8px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
